import styled from "styled-components";

import colors from "core/colors";
import { BorderBottomLinkStyle, CustomFocusStyle } from "core/Typography";
import Info from "core/ReusableIcons/Info";
import Tooltip from "core/Tooltip";

import { convertPxToRem } from "frontend/components/helpers";

import { rapidEasing } from "core/animation";

export const InfoIconTooltip = styled(Tooltip)`
    position: relative;
    top: ${convertPxToRem({ px: 0.8 })};
`;

export const IconButton = styled.button`
    cursor: pointer;
    border: 0;
    padding: 0;
    background-color: transparent;
`;

export const InfoIcon = styled(Info).attrs({
    fillColor: colors.accent.darkMode.suenosBuenos,
    size: "md"
})``;

export const Link = styled.a`
    ${BorderBottomLinkStyle}
    color: ${colors.accent.darkMode.suenosBuenos};
    border-color: ${colors.accent.darkMode.suenosBuenos};
    transition: color ${rapidEasing}, border-bottom-color ${rapidEasing};
    &:hover {
        color: ${colors.primary.diamond};
        border-color: ${colors.primary.diamond};
    }
    ${CustomFocusStyle}
`;

const ATTRIBUTION_AREA_HEIGHT = 168;

export const StyledAnimationContainer = styled.div`
    position: relative;
    z-index: 0;
    animation: ${({ startAnimation }) =>
        startAnimation ? "slide-in 700ms" : null};

    @keyframes slide-in {
        from {
            transform: translateY(
                -${convertPxToRem({ px: ATTRIBUTION_AREA_HEIGHT })}
            );
        }
        to {
            transform: translateY(0px);
        }
    }
`;
